import { render, staticRenderFns } from "./CorrespondenceBody.vue?vue&type=template&id=2fdf8dbc&"
import script from "./CorrespondenceBody.vue?vue&type=script&lang=js&"
export * from "./CorrespondenceBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports